export interface MealPlanAllergyConflict {
  day: string;
  meal: string;
  item: string;
  allergen: string;
}

const LABELS: Record<string, string> = {
  monday: 'Segunda-feira',
  tuesday: 'Terça-feira',
  wednesday: 'Quarta-feira',
  thursday: 'Quinta-feira',
  friday: 'Sexta-feira',
  saturday: 'Sábado',
  sunday: 'Domingo',
  breakfast: 'Café da manhã',
  morningSnack: 'Lanche da manhã',
  lunch: 'Almoço',
  afternoonSnack: 'Lanche da tarde',
  dinner: 'Jantar',
  eveningSnack: 'Ceia',
};

function normalize(value: string): string {
  return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
}

function hasAny(text: string, terms: string[]): boolean {
  return terms.some((term) => new RegExp(`\\b${term}\\b`, 'i').test(text));
}

/** Encontra conflitos dos alérgenos comuns declarados no perfil com os itens do plano. */
export function findMealPlanAllergyConflicts(
  allergies: string | null | undefined,
  weeklyPlan: unknown
): MealPlanAllergyConflict[] {
  if (!allergies || !weeklyPlan || typeof weeklyPlan !== 'object') return [];

  const allergyText = normalize(allergies);
  const rules: Array<{ label: string; allergyTerms: string[]; foodTerms: string[] }> = [
    {
      label: 'frutos do mar',
      allergyTerms: ['frutos do mar', 'marisco', 'mariscos', 'crustaceo', 'crustaceos', 'camarao', 'peixe', 'peixes'],
      foodTerms: ['camarao', 'lagosta', 'caranguejo', 'siri', 'mexilhao', 'ostra', 'lula', 'polvo', 'tilapia', 'salmao', 'atum', 'bacalhau', 'peixe', 'frutos do mar', 'fruto do mar'],
    },
    {
      label: 'nozes/castanhas',
      allergyTerms: ['noz', 'nozes', 'castanha', 'castanhas', 'amendoim', 'amendoins', 'nuts'],
      foodTerms: ['noz', 'nozes', 'castanha', 'castanhas', 'amendoim', 'amendoins', 'amendoa', 'amendoas', 'avelas', 'pistache', 'pistaches'],
    },
  ];
  const activeRules = rules.filter((rule) => hasAny(allergyText, rule.allergyTerms));
  if (activeRules.length === 0) return [];

  const conflicts: MealPlanAllergyConflict[] = [];
  Object.entries(weeklyPlan as Record<string, unknown>).forEach(([day, rawMeals]) => {
    const meals = rawMeals as Record<string, unknown> | null;
    if (!meals || typeof meals !== 'object') return;
    Object.entries(meals).forEach(([meal, rawItems]) => {
      const items = Array.isArray(rawItems) ? rawItems : [];
      items.forEach((rawItem) => {
        if (typeof rawItem !== 'string' || !rawItem.trim()) return;
        const item = normalize(rawItem);
        activeRules.forEach((rule) => {
          if (hasAny(item, rule.foodTerms)) {
            conflicts.push({
              day: LABELS[day] || day,
              meal: LABELS[meal] || meal,
              item: rawItem,
              allergen: rule.label,
            });
          }
        });
      });
    });
  });

  return conflicts;
}
